import React, { memo } from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'SISTEMA DE FICHAS PROFESIONALES™',
  desc: 'Plantillas listas para organizar mejor información clave de clientas.',
  price: '$8.000 ARS'
}, {
  num: 2,
  title: 'SCRIPTS DE RESPUESTA PROFESIONAL™',
  desc: 'Respuestas estructuradas para situaciones frecuentes.',
  price: '$9.000 ARS'
}, {
  num: 3,
  title: 'CHECKLISTS OPERATIVOS EXPRESS™',
  desc: 'Checklists para reducir errores y sostener orden.',
  price: '$7.000 ARS'
}, {
  num: 4,
  title: 'SISTEMA SIMPLE DE AGENDA Y SEGUIMIENTO™',
  desc: 'Herramientas para organizar citas y continuidad.',
  price: '$6.000 ARS'
}, {
  num: 5,
  title: 'KIT DE SITUACIONES DIFÍCILES™',
  desc: 'Recursos para reclamos, objeciones y situaciones incómodas.',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'KIT EXPERIENCIA PREMIUM™',
  desc: 'Recursos para elevar experiencia clienta y percepción profesional.',
  price: '$8.000 ARS'
}];
export function BonusSection() {
  return <section className="pt-6 pb-16 px-5 relative bg-[#0B0B12] overflow-hidden" data-id="element-27">
      <div className="blur-circle bg-brand-gold/10 -top-20 -right-20 opacity-20" data-id="element-28" />
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4 leading-tight uppercase tracking-tight" data-id="element-31">
            <GiftIcon className="inline-block mr-3 text-brand-gold mb-1" size={32} data-id="element-32" />
            ADEMÁS RECIBÍS ESTOS{' '}
            <span className="gold-text-gradient" data-id="element-33">BONOS ESTRATÉGICOS</span> SIN
            COSTO
          </h2>
          <p className="text-[10px] font-black text-slate-500 uppercase tracking-[0.3em]" data-id="element-34">
            Diseñados para ayudarte a IMPLEMENTAR más rápido
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10" data-id="element-35">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 relative overflow-hidden transition-all hover:shadow-[0_0_20px_rgba(212,176,106,0.15)] hover:border-brand-gold/40 group" data-id="element-36">
              <div className="absolute top-3 right-3 bg-brand-gold text-black text-[9px] font-black px-2 py-0.5 rounded-full flex items-center gap-1 shadow-[0_0_10px_rgba(212,176,106,0.3)]" data-id="element-37">
                <GiftIcon size={10} data-id="element-38" /> GRATIS
              </div>

              <div className="flex items-center gap-3 mb-3" data-id="element-39">
                <div className="bg-brand-gold/10 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 border border-brand-gold/20 group-hover:scale-110 transition-transform" data-id="element-40">
                  <GiftIcon size={18} className="text-brand-gold" data-id="element-41" />
                </div>
                <span className="text-[10px] text-slate-500 font-black uppercase tracking-widest" data-id="element-42">
                  BONO {bonus.num}
                </span>
              </div>

              <h3 className="text-sm font-black text-white mb-2 pr-12 uppercase tracking-tight leading-tight" data-id="element-43">
                {bonus.title}
              </h3>
              <p className="text-xs text-slate-400 mb-4 leading-relaxed font-medium" data-id="element-44">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-3 mt-auto pt-2 border-t border-white/5" data-id="element-45">
                <span className="text-[10px] text-slate-500 line-through font-bold" data-id="element-46">
                  {bonus.price}
                </span>
                <span className="text-[10px] font-black text-brand-gold uppercase tracking-widest" data-id="element-47">
                  HOY: $0
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-gradient-to-br from-white/10 to-white/5 border-2 border-brand-gold/30 rounded-2xl p-6 text-center shadow-2xl backdrop-blur-md max-w-2xl mx-auto" data-id="element-48">
          <p className="text-slate-500 text-[10px] line-through mb-1 font-black uppercase tracking-widest" data-id="element-49">
            Valor total bonos: +$45.000 ARS
          </p>
          <div className="flex items-center justify-center gap-3 mb-1" data-id="element-50">
            <GiftIcon className="text-brand-gold" size={28} data-id="element-51" />
            <p className="text-2xl md:text-3xl font-black gold-text-gradient uppercase tracking-tighter" data-id="element-52">
              TODO INCLUIDO: GRATIS
            </p>
          </div>
          <p className="text-[9px] text-slate-500 mt-2 font-black uppercase tracking-[0.2em]" data-id="element-53">
            (solo mientras esta oferta esté activa)
          </p>
        </div>
      </div>
    </section>;
}